<template>
    <div class="button-locked">
        <ButtonBlock
            :buttonText="buttonText"
            :buttonClick="openDialog"
            :buttonColor="buttonColor"
        ></ButtonBlock>
        <LayoutDialog
            v-if="dialog"
        >
            <template v-slot:content>
                <p class="mb-3 text-2xl font-semibold leading-10 sm:text-3xl">
                    Sign in to your <br />{{ $config.public.siteName }} account
                </p>
                <p class="sm:text-lg">It's quick, easy and free!</p>
            </template>
            <template v-slot:buttons>
                <div>
                    <ButtonPrimary
                        buttonRoute="/signup"
                        buttonText="Signup"
                    ></ButtonPrimary>
                    <ButtonRegular
                        class="ml-3"
                        v-if="!isLoggedIn"
                        buttonRoute="/login"
                        buttonText="Login"
                    ></ButtonRegular>
                    <div class="mt-8">
                        <button class="font-semibold text-zinc-600 underline hover:no-underline" @click="closeDialog">
                            Maybe Later
                        </button>
                    </div>
                </div>
            </template>
        </LayoutDialog>
    </div>
</template>

<script>
import { mapState } from 'pinia';

export default {
    name: 'ButtonLocked',
    props: [
        'error',
        'dialogTitle',
        'buttonText',
        'buttonColor',
        'cancelText',
        'submitText',
        'submitDisabled',
    ],
    emits: ['cancelled', 'submitted'],
    data () {
        return {
            dialog: false,
        };
    },
    computed: {
        ...mapState(useStoreAuth, {
            isLoggedIn: 'isLoggedIn',
        }),
    },
    methods: {
        openDialog () {
            this.dialog = true;
        },
        closeDialog () {
            this.dialog = false;
        },
        clickCancel () {
            this.dialog = false;
            this.$emit('cancelled');
        },
        clickSubmit () {
            this.$emit('submitted');
        },
    },
};
</script>
